!(function(e) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    var t;
    (
      (t =
        "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : this).braintree || (t.braintree = {})
    ).threeDSecure = e();
  }
})(function() {
  return (function o(s, a, c) {
    function l(t, e) {
      if (!a[t]) {
        if (!s[t]) {
          var n = "function" == typeof require && require;
          if (!e && n) return n(t, !0);
          if (u) return u(t, !0);
          var r = new Error("Cannot find module '" + t + "'");
          throw ((r.code = "MODULE_NOT_FOUND"), r);
        }
        var i = (a[t] = { exports: {} });
        s[t][0].call(
          i.exports,
          function(e) {
            return l(s[t][1][e] || e);
          },
          i,
          i.exports,
          o,
          s,
          a,
          c
        );
      }
      return a[t].exports;
    }
    for (
      var u = "function" == typeof require && require, e = 0;
      e < c.length;
      e++
    )
      l(c[e]);
    return l;
  })(
    {
      1: [
        function(n, r, e) {
          (function(e) {
            "use strict";
            var t = n("promise-polyfill");
            r.exports = e.Promise || t;
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "promise-polyfill": 12 }
      ],
      2: [
        function(e, t, n) {
          "use strict";
          var s = e("./lib/promise"),
            a = {};
          function r(n) {
            var t,
              r,
              i,
              e,
              o = JSON.stringify(n);
            return !n.forceScriptReload && (e = a[o])
              ? e
              : ((i = document.createElement("script")),
                (t = n.dataAttributes || {}),
                (r = n.container || document.head),
                (i.src = n.src),
                (i.id = n.id),
                (i.async = !0),
                n.crossorigin && i.setAttribute("crossorigin", n.crossorigin),
                Object.keys(t).forEach(function(e) {
                  i.setAttribute("data-" + e, t[e]);
                }),
                (e = new s(function(e, t) {
                  i.addEventListener("load", function() {
                    e(i);
                  }),
                    i.addEventListener("error", function() {
                      t(new Error(n.src + " failed to load."));
                    }),
                    i.addEventListener("abort", function() {
                      t(new Error(n.src + " has aborted."));
                    }),
                    r.appendChild(i);
                })),
                (a[o] = e));
          }
          (r.clearCache = function() {
            a = {};
          }),
            (t.exports = r);
        },
        { "./lib/promise": 1 }
      ],
      3: [
        function(e, t, n) {
          "use strict";
          var r = e("./lib/set-attributes"),
            i = e("./lib/default-attributes"),
            o = e("./lib/assign");
          t.exports = function(e) {
            var t = document.createElement("iframe"),
              n = o({}, i, e);
            return (
              n.style &&
                "string" != typeof n.style &&
                (o(t.style, n.style), delete n.style),
              r(t, n),
              t.getAttribute("id") || (t.id = t.name),
              t
            );
          };
        },
        {
          "./lib/assign": 4,
          "./lib/default-attributes": 5,
          "./lib/set-attributes": 6
        }
      ],
      4: [
        function(e, t, n) {
          "use strict";
          t.exports = function(n) {
            return (
              Array.prototype.slice.call(arguments, 1).forEach(function(t) {
                "object" == typeof t &&
                  Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                  });
              }),
              n
            );
          };
        },
        {}
      ],
      5: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            src: "about:blank",
            frameBorder: 0,
            allowtransparency: !0,
            scrolling: "no"
          };
        },
        {}
      ],
      6: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e, t) {
            var n;
            for (var r in t)
              t.hasOwnProperty(r) &&
                (null == (n = t[r])
                  ? e.removeAttribute(r)
                  : e.setAttribute(r, n));
          };
        },
        {}
      ],
      7: [
        function(e, t, n) {
          "use strict";
          t.exports = function(t) {
            return function() {
              var e = arguments;
              setTimeout(function() {
                try {
                  t.apply(null, e);
                } catch (e) {
                  console.log("Error in callback function"), console.log(e);
                }
              }, 1);
            };
          };
        },
        {}
      ],
      8: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            var t = !1;
            return function() {
              t || ((t = !0), e.apply(null, arguments));
            };
          };
        },
        {}
      ],
      9: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e, t) {
            if (!t) return e;
            e.then(function(e) {
              t(null, e);
            }).catch(function(e) {
              t(e);
            });
          };
        },
        {}
      ],
      10: [
        function(e, t, n) {
          "use strict";
          var r = e("./lib/deferred"),
            i = e("./lib/once"),
            o = e("./lib/promise-or-callback");
          function a(n) {
            return function() {
              var e,
                t = Array.prototype.slice.call(arguments);
              return (
                "function" == typeof t[t.length - 1] &&
                  ((e = t.pop()), (e = i(r(e)))),
                o(n.apply(this, t), e)
              );
            };
          }
          (a.wrapPrototype = function(i, e) {
            var o, s;
            return (
              (o = (e = e || {}).ignoreMethods || []),
              (s = !0 === e.transformPrivateMethods),
              Object.getOwnPropertyNames(i.prototype)
                .filter(function(e) {
                  var t,
                    n =
                      "constructor" !== e &&
                      "function" == typeof i.prototype[e],
                    r = -1 === o.indexOf(e);
                  return (t = s || "_" !== e.charAt(0)), n && t && r;
                })
                .forEach(function(e) {
                  var t = i.prototype[e];
                  i.prototype[e] = a(t);
                }),
              i
            );
          }),
            (t.exports = a);
        },
        { "./lib/deferred": 7, "./lib/once": 8, "./lib/promise-or-callback": 9 }
      ],
      11: [
        function(e, g, t) {
          (function(t) {
            "use strict";
            var r,
              s,
              o = [],
              a = {},
              c = "/*framebus*/";
            function e(e) {
              var t,
                n = l(this);
              return (
                !u(e) &&
                !u(n) &&
                !1 !==
                  (t = d(e, Array.prototype.slice.call(arguments, 1), n)) &&
                (m(r.top || r.self, t, n), !0)
              );
            }
            function n(e, t) {
              var n = l(this);
              return (
                !b(e, t, n) &&
                ((a[n] = a[n] || {}),
                (a[n][e] = a[n][e] || []),
                a[n][e].push(t),
                !0)
              );
            }
            function i(e, t) {
              var n,
                r,
                i = l(this);
              if (b(e, t, i)) return !1;
              if (!(r = a[i] && a[i][e])) return !1;
              for (n = 0; n < r.length; n++)
                if (r[n] === t) return r.splice(n, 1), !0;
              return !1;
            }
            function l(e) {
              return (e && e._origin) || "*";
            }
            function u(e) {
              return "string" != typeof e;
            }
            function d(e, t, n) {
              var r = !1,
                i = { event: e, origin: n },
                o = t[t.length - 1];
              "function" == typeof o &&
                ((i.reply = y(o, n)), (t = t.slice(0, -1))),
                (i.args = t);
              try {
                r = c + JSON.stringify(i);
              } catch (e) {
                throw new Error("Could not stringify event: " + e.message);
              }
              return r;
            }
            function f(e) {
              var t, n, r, i;
              if (e.data.slice(0, c.length) !== c) return !1;
              try {
                t = JSON.parse(e.data.slice(c.length));
              } catch (e) {
                return !1;
              }
              return (
                null != t.reply &&
                  ((n = e.origin),
                  (r = e.source),
                  (i = t.reply),
                  (t.reply = function(e) {
                    var t;
                    return (
                      !!r &&
                      !1 !== (t = d(i, [e], n)) &&
                      void r.postMessage(t, n)
                    );
                  }),
                  t.args.push(t.reply)),
                t
              );
            }
            function p(e) {
              r ||
                ((r = e || t).addEventListener
                  ? r.addEventListener("message", h, !1)
                  : r.attachEvent
                  ? r.attachEvent("onmessage", h)
                  : null === r.onmessage
                  ? (r.onmessage = h)
                  : (r = null));
            }
            function _() {
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function(e) {
                  var t = (16 * Math.random()) | 0;
                  return ("x" === e ? t : (3 & t) | 8).toString(16);
                }
              );
            }
            function h(e) {
              var t;
              u(e.data) ||
                ((t = f(e)) &&
                  (E("*", t.event, t.args, e),
                  E(e.origin, t.event, t.args, e),
                  (function(e, t, n) {
                    var r, i;
                    for (r = o.length - 1; 0 <= r; r--)
                      !0 === (i = o[r]).closed
                        ? (o = o.slice(r, 1))
                        : n !== i && m(i.top, e, t);
                  })(e.data, t.origin, e.source)));
            }
            function E(e, t, n, r) {
              var i;
              if (a[e] && a[e][t])
                for (i = 0; i < a[e][t].length; i++) a[e][t][i].apply(r, n);
            }
            function m(e, t, n) {
              var r,
                i = 0;
              try {
                for (
                  e.postMessage(t, n),
                    (function(e) {
                      return (
                        e.top === e &&
                        null != e.opener &&
                        e.opener !== e &&
                        !0 !== e.opener.closed
                      );
                    })(e) && m(e.opener.top, t, n);
                  (r = e.frames[i]);

                )
                  m(r, t, n), i++;
              } catch (e) {}
            }
            function y(r, i) {
              var o = _();
              return (
                s.target(i).subscribe(o, function e(t, n) {
                  r(t, n), s.target(i).unsubscribe(o, e);
                }),
                o
              );
            }
            function b(e, t, n) {
              return !!u(e) || "function" != typeof t || !!u(n);
            }
            p(),
              (s = {
                target: function(e) {
                  var t,
                    n = {};
                  for (t in s) s.hasOwnProperty(t) && (n[t] = s[t]);
                  return (n._origin = e || "*"), n;
                },
                _packagePayload: d,
                _unpackPayload: f,
                _attach: p,
                _detach: function() {
                  null != r &&
                    (r.removeEventListener
                      ? r.removeEventListener("message", h, !1)
                      : r.detachEvent
                      ? r.detachEvent("onmessage", h)
                      : r.onmessage === h && (r.onmessage = null),
                    (r = null),
                    (o = []),
                    (a = {}));
                },
                _dispatch: E,
                _broadcast: m,
                _subscribeReplier: y,
                _subscriptionArgsInvalid: b,
                _onmessage: h,
                _uuid: _,
                _getSubscribers: function() {
                  return a;
                },
                _win: function() {
                  return r;
                },
                include: function(e) {
                  return (
                    null != e &&
                    null != e.Window &&
                    e.constructor === e.Window &&
                    (o.push(e), !0)
                  );
                },
                publish: e,
                pub: e,
                trigger: e,
                emit: e,
                subscribe: n,
                sub: n,
                on: n,
                unsubscribe: i,
                unsub: i,
                off: i
              }),
              (g.exports = s);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      12: [
        function(e, t, n) {
          "use strict";
          var r = setTimeout;
          function c(e) {
            return Boolean(e && void 0 !== e.length);
          }
          function i() {}
          function o(e) {
            if (!(this instanceof o))
              throw new TypeError("Promises must be constructed via new");
            if ("function" != typeof e) throw new TypeError("not a function");
            (this._state = 0),
              (this._handled = !1),
              (this._value = void 0),
              (this._deferreds = []),
              f(e, this);
          }
          function s(n, r) {
            for (; 3 === n._state; ) n = n._value;
            0 !== n._state
              ? ((n._handled = !0),
                o._immediateFn(function() {
                  var e = 1 === n._state ? r.onFulfilled : r.onRejected;
                  if (null !== e) {
                    var t;
                    try {
                      t = e(n._value);
                    } catch (e) {
                      return void l(r.promise, e);
                    }
                    a(r.promise, t);
                  } else (1 === n._state ? a : l)(r.promise, n._value);
                }))
              : n._deferreds.push(r);
          }
          function a(t, e) {
            try {
              if (e === t)
                throw new TypeError(
                  "A promise cannot be resolved with itself."
                );
              if (e && ("object" == typeof e || "function" == typeof e)) {
                var n = e.then;
                if (e instanceof o)
                  return (t._state = 3), (t._value = e), void u(t);
                if ("function" == typeof n)
                  return void f(
                    (function(e, t) {
                      return function() {
                        e.apply(t, arguments);
                      };
                    })(n, e),
                    t
                  );
              }
              (t._state = 1), (t._value = e), u(t);
            } catch (e) {
              l(t, e);
            }
          }
          function l(e, t) {
            (e._state = 2), (e._value = t), u(e);
          }
          function u(e) {
            2 === e._state &&
              0 === e._deferreds.length &&
              o._immediateFn(function() {
                e._handled || o._unhandledRejectionFn(e._value);
              });
            for (var t = 0, n = e._deferreds.length; t < n; t++)
              s(e, e._deferreds[t]);
            e._deferreds = null;
          }
          function d(e, t, n) {
            (this.onFulfilled = "function" == typeof e ? e : null),
              (this.onRejected = "function" == typeof t ? t : null),
              (this.promise = n);
          }
          function f(e, t) {
            var n = !1;
            try {
              e(
                function(e) {
                  n || ((n = !0), a(t, e));
                },
                function(e) {
                  n || ((n = !0), l(t, e));
                }
              );
            } catch (e) {
              if (n) return;
              (n = !0), l(t, e);
            }
          }
          (o.prototype.catch = function(e) {
            return this.then(null, e);
          }),
            (o.prototype.then = function(e, t) {
              var n = new this.constructor(i);
              return s(this, new d(e, t, n)), n;
            }),
            (o.prototype.finally = function(t) {
              var n = this.constructor;
              return this.then(
                function(e) {
                  return n.resolve(t()).then(function() {
                    return e;
                  });
                },
                function(e) {
                  return n.resolve(t()).then(function() {
                    return n.reject(e);
                  });
                }
              );
            }),
            (o.all = function(t) {
              return new o(function(r, i) {
                if (!c(t))
                  return i(new TypeError("Promise.all accepts an array"));
                var o = Array.prototype.slice.call(t);
                if (0 === o.length) return r([]);
                var s = o.length;
                function a(t, e) {
                  try {
                    if (e && ("object" == typeof e || "function" == typeof e)) {
                      var n = e.then;
                      if ("function" == typeof n)
                        return void n.call(
                          e,
                          function(e) {
                            a(t, e);
                          },
                          i
                        );
                    }
                    (o[t] = e), 0 == --s && r(o);
                  } catch (e) {
                    i(e);
                  }
                }
                for (var e = 0; e < o.length; e++) a(e, o[e]);
              });
            }),
            (o.resolve = function(t) {
              return t && "object" == typeof t && t.constructor === o
                ? t
                : new o(function(e) {
                    e(t);
                  });
            }),
            (o.reject = function(n) {
              return new o(function(e, t) {
                t(n);
              });
            }),
            (o.race = function(i) {
              return new o(function(e, t) {
                if (!c(i))
                  return t(new TypeError("Promise.race accepts an array"));
                for (var n = 0, r = i.length; n < r; n++)
                  o.resolve(i[n]).then(e, t);
              });
            }),
            (o._immediateFn =
              ("function" == typeof setImmediate &&
                function(e) {
                  setImmediate(e);
                }) ||
              function(e) {
                r(e, 0);
              }),
            (o._unhandledRejectionFn = function(e) {
              "undefined" != typeof console &&
                console &&
                console.warn("Possible Unhandled Promise Rejection:", e);
            }),
            (t.exports = o);
        },
        {}
      ],
      13: [
        function(e, t, n) {
          "use strict";
          var s = e("./create-authorization-data"),
            a = e("./json-clone"),
            c = e("./constants");
          t.exports = function(e, t) {
            var n,
              r = t ? a(t) : {},
              i = s(e.authorization).attrs,
              o = a(e.analyticsMetadata);
            for (n in ((r.braintreeLibraryVersion =
              c.BRAINTREE_LIBRARY_VERSION),
            r._meta))
              r._meta.hasOwnProperty(n) && (o[n] = r._meta[n]);
            return (
              (r._meta = o),
              i.tokenizationKey
                ? (r.tokenizationKey = i.tokenizationKey)
                : (r.authorizationFingerprint = i.authorizationFingerprint),
              r
            );
          };
        },
        {
          "./constants": 22,
          "./create-authorization-data": 26,
          "./json-clone": 33
        }
      ],
      14: [
        function(e, t, n) {
          "use strict";
          var r = e("./promise"),
            l = e("./constants"),
            u = e("./add-metadata");
          function d(e) {
            return Math.floor(e / 1e3);
          }
          t.exports = {
            sendEvent: function(e, s, a) {
              var c = d(Date.now());
              return r.resolve(e).then(function(e) {
                var t = d(Date.now()),
                  n = e.getConfiguration(),
                  r = e._request,
                  i = n.gatewayConfiguration.analytics.url,
                  o = {
                    analytics: [
                      {
                        kind: l.ANALYTICS_PREFIX + s,
                        isAsync: t !== c,
                        timestamp: c
                      }
                    ]
                  };
                r(
                  {
                    url: i,
                    method: "post",
                    data: u(n, o),
                    timeout: l.ANALYTICS_REQUEST_TIMEOUT_MS
                  },
                  a
                );
              });
            }
          };
        },
        { "./add-metadata": 13, "./constants": 22, "./promise": 35 }
      ],
      15: [
        function(e, t, n) {
          "use strict";
          var r = e("@braintree/asset-loader/load-script");
          t.exports = { loadScript: r };
        },
        { "@braintree/asset-loader/load-script": 2 }
      ],
      16: [
        function(e, t, n) {
          "use strict";
          var r = "function" == typeof Object.assign ? Object.assign : i;
          function i(e) {
            var t, n, r;
            for (t = 1; t < arguments.length; t++)
              for (r in (n = arguments[t]))
                n.hasOwnProperty(r) && (e[r] = n[r]);
            return e;
          }
          t.exports = { assign: r, _assign: i };
        },
        {}
      ],
      17: [
        function(e, t, n) {
          "use strict";
          var i = e("./braintree-error"),
            o = e("./promise"),
            s = e("./errors");
          t.exports = {
            verify: function(e) {
              var t, n, r;
              return e
                ? ((r = e.name),
                  (t = e.client),
                  (n = e.authorization),
                  null == t && null == n
                    ? o.reject(
                        new i({
                          type: s.INSTANTIATION_OPTION_REQUIRED.type,
                          code: s.INSTANTIATION_OPTION_REQUIRED.code,
                          message:
                            "options.client is required when instantiating " +
                            r +
                            "."
                        })
                      )
                    : n || "3.47.0" === t.getVersion()
                    ? o.resolve()
                    : o.reject(
                        new i({
                          type: s.INCOMPATIBLE_VERSIONS.type,
                          code: s.INCOMPATIBLE_VERSIONS.code,
                          message:
                            "Client (version " +
                            t.getVersion() +
                            ") and " +
                            r +
                            " (version 3.47.0) components must be from the same SDK version."
                        })
                      ))
                : o.reject(
                    new i({
                      type: s.INVALID_USE_OF_INTERNAL_FUNCTION.type,
                      code: s.INVALID_USE_OF_INTERNAL_FUNCTION.code,
                      message:
                        "Options must be passed to basicComponentVerification function."
                    })
                  );
            }
          };
        },
        { "./braintree-error": 18, "./errors": 30, "./promise": 35 }
      ],
      18: [
        function(e, t, n) {
          "use strict";
          var r = e("./enumerate");
          function i(e) {
            if (!i.types.hasOwnProperty(e.type))
              throw new Error(e.type + " is not a valid type.");
            if (!e.code) throw new Error("Error code required.");
            if (!e.message) throw new Error("Error message required.");
            (this.name = "BraintreeError"),
              (this.code = e.code),
              (this.message = e.message),
              (this.type = e.type),
              (this.details = e.details);
          }
          (((i.prototype = Object.create(
            Error.prototype
          )).constructor = i).types = r([
            "CUSTOMER",
            "MERCHANT",
            "NETWORK",
            "INTERNAL",
            "UNKNOWN"
          ])),
            (i.findRootError = function(e) {
              return e instanceof i && e.details && e.details.originalError
                ? i.findRootError(e.details.originalError)
                : e;
            }),
            (t.exports = i);
        },
        { "./enumerate": 29 }
      ],
      19: [
        function(e, t, n) {
          "use strict";
          var i = e("../is-verified-domain");
          t.exports = {
            checkOrigin: function(e, t) {
              var n,
                r = document.createElement("a");
              return (
                (r.href = t),
                (n =
                  "https:" === r.protocol
                    ? r.host.replace(/:443$/, "")
                    : "http:" === r.protocol
                    ? r.host.replace(/:80$/, "")
                    : r.host),
                r.protocol + "//" + n === e || ((r.href = e), i(e))
              );
            }
          };
        },
        { "../is-verified-domain": 32 }
      ],
      20: [
        function(e, t, n) {
          "use strict";
          var r = e("../enumerate");
          t.exports = r(["CONFIGURATION_REQUEST"], "bus:");
        },
        { "../enumerate": 29 }
      ],
      21: [
        function(e, t, n) {
          "use strict";
          var s = e("framebus"),
            r = e("./events"),
            a = e("./check-origin").checkOrigin,
            i = e("../braintree-error");
          function o(e) {
            if (((e = e || {}), (this.channel = e.channel), !this.channel))
              throw new i({
                type: i.types.INTERNAL,
                code: "MISSING_CHANNEL_ID",
                message: "Channel ID must be specified."
              });
            (this.merchantUrl = e.merchantUrl),
              (this._isDestroyed = !1),
              (this._isVerbose = !1),
              (this._listeners = []),
              this._log("new bus on channel " + this.channel, [location.href]);
          }
          (o.prototype.on = function(e, t) {
            var n,
              r,
              i = t,
              o = this;
            this._isDestroyed ||
              (this.merchantUrl &&
                (i = function() {
                  a(this.origin, o.merchantUrl) && t.apply(this, arguments);
                }),
              (n = this._namespaceEvent(e)),
              ((r = Array.prototype.slice.call(arguments))[0] = n),
              (r[1] = i),
              this._log("on", r),
              s.on.apply(s, r),
              this._listeners.push({
                eventName: e,
                handler: i,
                originalHandler: t
              }));
          }),
            (o.prototype.emit = function(e) {
              var t;
              this._isDestroyed ||
                (((t = Array.prototype.slice.call(
                  arguments
                ))[0] = this._namespaceEvent(e)),
                this._log("emit", t),
                s.emit.apply(s, t));
            }),
            (o.prototype._offDirect = function(e) {
              var t = Array.prototype.slice.call(arguments);
              this._isDestroyed ||
                ((t[0] = this._namespaceEvent(e)),
                this._log("off", t),
                s.off.apply(s, t));
            }),
            (o.prototype.off = function(e, t) {
              var n,
                r,
                i = t;
              if (!this._isDestroyed) {
                if (this.merchantUrl)
                  for (n = 0; n < this._listeners.length; n++)
                    (r = this._listeners[n]).originalHandler === t &&
                      (i = r.handler);
                this._offDirect(e, i);
              }
            }),
            (o.prototype._namespaceEvent = function(e) {
              return ["braintree", this.channel, e].join(":");
            }),
            (o.prototype.teardown = function() {
              var e, t;
              for (t = 0; t < this._listeners.length; t++)
                (e = this._listeners[t]),
                  this._offDirect(e.eventName, e.handler);
              (this._listeners.length = 0), (this._isDestroyed = !0);
            }),
            (o.prototype._log = function(e, t) {
              this._isVerbose && console.log(e, t);
            }),
            (o.events = r),
            (t.exports = o);
        },
        {
          "../braintree-error": 18,
          "./check-origin": 19,
          "./events": 20,
          framebus: 11
        }
      ],
      22: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            ANALYTICS_PREFIX: "web.",
            ANALYTICS_REQUEST_TIMEOUT_MS: 2e3,
            ASSETS_URLS: {
              production: "https://assets.braintreegateway.com",
              sandbox: "https://assets.braintreegateway.com"
            },
            CLIENT_API_URLS: {
              production: "https://api.braintreegateway.com:443",
              sandbox: "https://api.sandbox.braintreegateway.com:443"
            },
            FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
            FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
            FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
            GRAPHQL_URLS: {
              production: "https://payments.braintree-api.com/graphql",
              sandbox: "https://payments.sandbox.braintree-api.com/graphql"
            },
            INTEGRATION_TIMEOUT_MS: 6e4,
            VERSION: "3.47.0",
            INTEGRATION: "custom",
            SOURCE: "client",
            PLATFORM: "web",
            BRAINTREE_LIBRARY_VERSION: "braintree/web/3.47.0"
          };
        },
        {}
      ],
      23: [
        function(e, t, n) {
          "use strict";
          var r = e("./braintree-error"),
            i = e("./errors");
          t.exports = function(t, e) {
            e.forEach(function(e) {
              t[e] = function() {
                throw new r({
                  type: i.METHOD_CALLED_AFTER_TEARDOWN.type,
                  code: i.METHOD_CALLED_AFTER_TEARDOWN.code,
                  message: e + " cannot be called after teardown."
                });
              };
            });
          };
        },
        { "./braintree-error": 18, "./errors": 30 }
      ],
      24: [
        function(e, t, n) {
          "use strict";
          var r = e("./braintree-error");
          t.exports = function(e, t) {
            return e instanceof r
              ? e
              : new r({
                  type: t.type,
                  code: t.code,
                  message: t.message,
                  details: { originalError: e }
                });
          };
        },
        { "./braintree-error": 18 }
      ],
      25: [
        function(e, t, n) {
          "use strict";
          var r = e("./constants").ASSETS_URLS;
          t.exports = {
            create: function(e) {
              return r.production;
            }
          };
        },
        { "./constants": 22 }
      ],
      26: [
        function(e, t, n) {
          "use strict";
          var i = e("../lib/vendor/polyfill").atob,
            o = e("../lib/constants").CLIENT_API_URLS;
          t.exports = function(e) {
            var t,
              n,
              r = { attrs: {}, configUrl: "" };
            return (
              !(function(e) {
                return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(e);
              })(e)
                ? ((t = JSON.parse(i(e))),
                  (r.environment = t.environment),
                  (r.attrs.authorizationFingerprint =
                    t.authorizationFingerprint),
                  (r.configUrl = t.configUrl),
                  (r.graphQL = t.graphQL))
                : ((n = (function(e) {
                    var t = e.split("_"),
                      n = t[0];
                    return { merchantId: t.slice(2).join("_"), environment: n };
                  })(e)),
                  (r.environment = n.environment),
                  (r.attrs.tokenizationKey = e),
                  (r.configUrl =
                    o[n.environment] +
                    "/merchants/" +
                    n.merchantId +
                    "/client_api/v1/configuration")),
              r
            );
          };
        },
        { "../lib/constants": 22, "../lib/vendor/polyfill": 37 }
      ],
      27: [
        function(e, t, n) {
          (function(n) {
            "use strict";
            var r = e("./braintree-error"),
              i = e("./promise"),
              o = e("./assets"),
              s = e("./errors"),
              a = "3.47.0";
            t.exports = {
              create: function(e) {
                var t = i.resolve();
                return e.client
                  ? i.resolve(e.client)
                  : ((n.braintree && n.braintree.client) ||
                      (t = o
                        .loadScript({
                          src: e.assetsUrl + "/web/" + a + "/js/client.min.js"
                        })
                        .catch(function(e) {
                          return i.reject(
                            new r({
                              type: s.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
                              code: s.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
                              message: s.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
                              details: { originalError: e }
                            })
                          );
                        })),
                    t.then(function() {
                      return n.braintree.client.VERSION !== a
                        ? i.reject(
                            new r({
                              type: s.INCOMPATIBLE_VERSIONS.type,
                              code: s.INCOMPATIBLE_VERSIONS.code,
                              message:
                                "Client (version " +
                                n.braintree.client.VERSION +
                                ") and " +
                                e.name +
                                " (version " +
                                a +
                                ") components must be from the same SDK version."
                            })
                          )
                        : n.braintree.client.create({
                            authorization: e.authorization,
                            debug: e.debug
                          });
                    }));
              }
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "./assets": 15,
          "./braintree-error": 18,
          "./errors": 30,
          "./promise": 35
        }
      ],
      28: [
        function(e, t, n) {
          "use strict";
          t.exports = function(t) {
            return function() {
              var e = arguments;
              setTimeout(function() {
                t.apply(null, e);
              }, 1);
            };
          };
        },
        {}
      ],
      29: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e, n) {
            return (
              (n = null == n ? "" : n),
              e.reduce(function(e, t) {
                return (e[t] = n + t), e;
              }, {})
            );
          };
        },
        {}
      ],
      30: [
        function(e, t, n) {
          "use strict";
          var r = e("./braintree-error");
          t.exports = {
            INVALID_USE_OF_INTERNAL_FUNCTION: {
              type: r.types.INTERNAL,
              code: "INVALID_USE_OF_INTERNAL_FUNCTION"
            },
            INSTANTIATION_OPTION_REQUIRED: {
              type: r.types.MERCHANT,
              code: "INSTANTIATION_OPTION_REQUIRED"
            },
            INCOMPATIBLE_VERSIONS: {
              type: r.types.MERCHANT,
              code: "INCOMPATIBLE_VERSIONS"
            },
            CLIENT_SCRIPT_FAILED_TO_LOAD: {
              type: r.types.NETWORK,
              code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
              message: "Braintree client script could not be loaded."
            },
            METHOD_CALLED_AFTER_TEARDOWN: {
              type: r.types.MERCHANT,
              code: "METHOD_CALLED_AFTER_TEARDOWN"
            },
            BRAINTREE_API_ACCESS_RESTRICTED: {
              type: r.types.MERCHANT,
              code: "BRAINTREE_API_ACCESS_RESTRICTED",
              message:
                "Your access is restricted and cannot use this part of the Braintree API."
            }
          };
        },
        { "./braintree-error": 18 }
      ],
      31: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            n.exports = {
              isHTTPS: function(e) {
                return "https:" === (e = e || t.location.protocol);
              }
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      32: [
        function(e, t, n) {
          "use strict";
          var r,
            i = {
              "paypal.com": 1,
              "braintreepayments.com": 1,
              "braintreegateway.com": 1,
              "braintree-api.com": 1
            };
          t.exports = function(e) {
            var t;
            return (
              (e = e.toLowerCase()),
              !!/^https:/.test(e) &&
                (((r = r || document.createElement("a")).href = e),
                (t = (function(e) {
                  return e
                    .split(".")
                    .slice(-2)
                    .join(".");
                })(r.hostname)),
                i.hasOwnProperty(t))
            );
          };
        },
        {}
      ],
      33: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            return JSON.parse(JSON.stringify(e));
          };
        },
        {}
      ],
      34: [
        function(e, t, n) {
          "use strict";
          t.exports = function(t) {
            return Object.keys(t).filter(function(e) {
              return "function" == typeof t[e];
            });
          };
        },
        {}
      ],
      35: [
        function(n, r, e) {
          (function(e) {
            "use strict";
            var t = e.Promise || n("promise-polyfill");
            r.exports = t;
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "promise-polyfill": 12 }
      ],
      36: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            return e ? "" : ".min";
          };
        },
        {}
      ],
      37: [
        function(e, r, t) {
          (function(t) {
            "use strict";
            var n = "function" == typeof t.atob ? t.atob : e;
            function e(e) {
              var t,
                n,
                r,
                i,
                o,
                s,
                a =
                  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                c = "";
              if (
                !new RegExp(
                  "^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$"
                ).test(e)
              )
                throw new Error(
                  "Non base64 encoded input passed to window.atob polyfill"
                );
              for (
                s = 0;
                (t =
                  ((63 & a.indexOf(e.charAt(s++))) << 2) |
                  (((i = a.indexOf(e.charAt(s++))) >> 4) & 3)),
                  (n =
                    ((15 & i) << 4) |
                    (((o = a.indexOf(e.charAt(s++))) >> 2) & 15)),
                  (r = ((3 & o) << 6) | (63 & a.indexOf(e.charAt(s++)))),
                  (c +=
                    String.fromCharCode(t) +
                    (n ? String.fromCharCode(n) : "") +
                    (r ? String.fromCharCode(r) : "")),
                  s < e.length;

              );
              return c;
            }
            r.exports = {
              atob: function(e) {
                return n.call(t, e);
              },
              _atob: e
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      38: [
        function(e, t, n) {
          "use strict";
          t.exports = function() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
              /[xy]/g,
              function(e) {
                var t = (16 * Math.random()) | 0;
                return ("x" === e ? t : (3 & t) | 8).toString(16);
              }
            );
          };
        },
        {}
      ],
      39: [
        function(T, R, e) {
          (function(c) {
            "use strict";
            var l = T("../../lib/braintree-error"),
              u = T("../../lib/convert-to-braintree-error"),
              d = T("../../lib/analytics"),
              f = T("../../lib/assign").assign,
              p = T("../../lib/assets"),
              e = T("../../lib/methods"),
              t = T("../../lib/convert-methods-to-error"),
              _ = T("../shared/constants"),
              o = T("../../lib/use-min"),
              s = T("../../lib/bus"),
              a = T("../../lib/vendor/uuid"),
              h = T("../../lib/deferred"),
              E = T("../shared/errors"),
              m = T("../shared/events"),
              y = T("@braintree/iframer"),
              b = T("../../lib/promise"),
              n = T("@braintree/wrap-promise"),
              g = T("../../lib/constants").INTEGRATION_TIMEOUT_MS,
              r = T("../../lib/constants").PLATFORM,
              A = "3.47.0";
            function i(e) {
              (this._options = e),
                (this._assetsUrl =
                  e.client.getConfiguration().gatewayConfiguration.assetsUrl +
                  "/web/" +
                  A),
                (this._isDebug = e.client.getConfiguration().isDebug),
                (this._client = e.client),
                (this._clientMetadata = {
                  sdkVersion: r + "/" + A,
                  requestedThreeDSecureVersion: this._usesSongbirdFlow()
                    ? "2"
                    : "1"
                });
            }
            (i.prototype.verifyCard = function(e) {
              var t,
                n,
                r,
                i,
                o,
                s,
                a,
                c = b.resolve(),
                l = e.additionalInformation || {},
                u = this;
              return (
                (e = f({}, e)),
                (s = this._checkForVerifyCardError(e))
                  ? b.reject(s)
                  : ((n = !1 !== e.showLoader),
                    (this._verifyCardInProgress = !0),
                    (t = { amount: e.amount }),
                    (a = e.nonce),
                    this._usesSongbirdFlow()
                      ? ((o = h(e.onLookupComplete)),
                        (l = this._transformBillingAddress(
                          l,
                          e.billingAddress
                        )),
                        (l = this._transformShippingAddress(l)),
                        e.email && (l.email = e.email),
                        e.mobilePhoneNumber &&
                          (l.mobilePhoneNumber = e.mobilePhoneNumber),
                        (t.additionalInfo = l),
                        e.challengeRequested &&
                          (t.challengeRequested = e.challengeRequested),
                        e.exemptionRequested &&
                          (t.exemptionRequested = e.exemptionRequested),
                        (c = this._prepareRawLookup(t).then(function(e) {
                          t = e;
                        })))
                      : ((r = h(e.addFrame)),
                        (i = h(e.removeFrame)),
                        e.customer &&
                          e.customer.billingAddress &&
                          ((e.customer = this._transformV1CustomerBillingAddress(
                            e.customer
                          )),
                          (t.customer = e.customer))),
                    d.sendEvent(
                      this._options.client,
                      "three-d-secure.verification-flow.started"
                    ),
                    c
                      .then(function() {
                        var e =
                          "payment_methods/" + a + "/three_d_secure/lookup";
                        return u._client.request({
                          endpoint: e,
                          method: "post",
                          data: t
                        });
                      })
                      .then(function(e) {
                        return (
                          d.sendEvent(
                            u._options.client,
                            "three-d-secure.verification-flow.3ds-version." +
                              e.lookup.threeDSecureVersion
                          ),
                          u._initializeChallengeWithLookupResponse(e, {
                            showLoader: n,
                            addFrame: r,
                            removeFrame: i,
                            onLookupComplete: o
                          })
                        );
                      })
                      .then(function(e) {
                        return (
                          d.sendEvent(
                            u._options.client,
                            "three-d-secure.verification-flow.completed"
                          ),
                          e
                        );
                      })
                      .catch(function(e) {
                        return (
                          (u._verifyCardInProgress = !1),
                          d.sendEvent(
                            u._options.client,
                            "three-d-secure.verification-flow.failed"
                          ),
                          b.reject(e)
                        );
                      }))
              );
            }),
              (i.prototype._checkForVerifyCardError = function(e) {
                var t;
                return this._verifyCardBlockingError
                  ? this._verifyCardBlockingError
                  : !0 === this._verifyCardInProgress
                  ? new l(E.THREEDS_AUTHENTICATION_IN_PROGRESS)
                  : (e.nonce ? e.amount || (t = "an amount") : (t = "a nonce"),
                    t ||
                      (this._usesSongbirdFlow()
                        ? "function" != typeof e.onLookupComplete &&
                          (t = "an onLookupComplete function")
                        : "function" != typeof e.addFrame
                        ? (t = "an addFrame function")
                        : "function" != typeof e.removeFrame &&
                          (t = "a removeFrame function")),
                    t
                      ? new l({
                          type: E.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
                          code: E.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
                          message: "verifyCard options must include " + t + "."
                        })
                      : null);
              }),
              (i.prototype.initializeChallengeWithLookupResponse = function(e) {
                return this._initializeChallengeWithLookupResponse(e);
              }),
              (i.prototype._initializeChallengeWithLookupResponse = function(
                e,
                t
              ) {
                var i = this;
                return (
                  (t = t || {}),
                  (this._lookupPaymentMethod = e.paymentMethod),
                  new b(function(n, r) {
                    (i._verifyCardCallback = function(e, t) {
                      (i._verifyCardInProgress = !1),
                        e
                          ? r(e)
                          : (d.sendEvent(
                              i._options.client,
                              "three-d-secure.verification-flow.liability-shifted." +
                                String(t.liabilityShifted)
                            ),
                            d.sendEvent(
                              i._options.client,
                              "three-d-secure.verification-flow.liability-shift-possible." +
                                String(t.liabilityShiftPossible)
                            ),
                            n(t));
                    }),
                      i._handleLookupResponse({
                        showLoader: t.showLoader,
                        lookupResponse: e,
                        addFrame: t.addFrame,
                        removeFrame: t.removeFrame,
                        onLookupComplete: t.onLookupComplete
                      });
                  })
                );
              }),
              (i.prototype.prepareLookup = function(e) {
                return this._prepareRawLookup(e).then(function(e) {
                  return JSON.stringify(e);
                });
              }),
              (i.prototype._prepareRawLookup = function(e) {
                var t = f({}, e),
                  n = this;
                return this._getDfReferenceId()
                  .then(function(e) {
                    t.dfReferenceId = e;
                  })
                  .then(function() {
                    return n._triggerCardinalBinProcess(e.bin);
                  })
                  .catch(function() {})
                  .then(function() {
                    return (
                      (t.clientMetadata = n._clientMetadata),
                      (t.authorizationFingerprint = n._client.getConfiguration().authorizationFingerprint),
                      (t.braintreeLibraryVersion = "braintree/web/" + A),
                      t
                    );
                  });
              }),
              (i.prototype._triggerCardinalBinProcess = function(e) {
                var t = this,
                  n = Date.now();
                return e
                  ? c.Cardinal.trigger("bin.process", e).then(function(e) {
                      (t._clientMetadata.issuerDeviceDataCollectionTimeElapsed =
                        Date.now() - n),
                        (t._clientMetadata.issuerDeviceDataCollectionResult =
                          e && e.Status);
                    })
                  : b.resolve();
              }),
              (i.prototype.cancelVerifyCard = function() {
                var e;
                return this._usesSongbirdFlow()
                  ? b.reject(
                      new l({
                        type: E.THREEDS_METHOD_DEPRECATED.type,
                        code: E.THREEDS_METHOD_DEPRECATED.code,
                        message:
                          "cancelVerifyCard can not be used with 3D Secure v2."
                      })
                    )
                  : ((this._verifyCardInProgress = !1),
                    this._lookupPaymentMethod
                      ? ((e = f({}, this._lookupPaymentMethod, {
                          liabilityShiftPossible: this._lookupPaymentMethod
                            .threeDSecureInfo.liabilityShiftPossible,
                          liabilityShifted: this._lookupPaymentMethod
                            .threeDSecureInfo.liabilityShifted,
                          verificationDetails: this._lookupPaymentMethod
                            .threeDSecureInfo.verificationDetails
                        })),
                        b.resolve(e))
                      : b.reject(new l(E.THREEDS_NO_VERIFICATION_PAYLOAD)));
              }),
              (i.prototype._handleLookupResponse = function(t) {
                var n,
                  r = this,
                  i = t.lookupResponse;
                (t.onLookupComplete =
                  t.onLookupComplete ||
                  function(e, t) {
                    t();
                  }),
                  t.onLookupComplete(i, function() {
                    var e = Boolean(i.lookup && i.lookup.acsUrl);
                    d.sendEvent(
                      r._options.client,
                      "three-d-secure.verification-flow.challenge-presented." +
                        String(e)
                    ),
                      e
                        ? r._usesSongbirdFlow()
                          ? c.Cardinal.continue(
                              "cca",
                              {
                                AcsUrl: i.lookup.acsUrl,
                                Payload: i.lookup.pareq
                              },
                              {
                                OrderDetails: {
                                  TransactionId: i.lookup.transactionId
                                }
                              }
                            )
                          : t.addFrame(
                              null,
                              r._createIframe({
                                showLoader: t.showLoader,
                                response: i.lookup,
                                removeFrame: t.removeFrame
                              })
                            )
                        : (((n = r._formatAuthResponse(
                            i.paymentMethod,
                            i.threeDSecureInfo
                          )).verificationDetails = i.threeDSecureInfo),
                          r._verifyCardCallback(null, n));
                  });
              }),
              (i.prototype._transformV1CustomerBillingAddress = function(e) {
                return (
                  (e.billingAddress.line1 = e.billingAddress.streetAddress),
                  (e.billingAddress.line2 = e.billingAddress.extendedAddress),
                  (e.billingAddress.city = e.billingAddress.locality),
                  (e.billingAddress.state = e.billingAddress.region),
                  (e.billingAddress.countryCode =
                    e.billingAddress.countryCodeAlpha2),
                  delete e.billingAddress.streetAddress,
                  delete e.billingAddress.extendedAddress,
                  delete e.billingAddress.locality,
                  delete e.billingAddress.region,
                  delete e.billingAddress.countryCodeAlpha2,
                  e
                );
              }),
              (i.prototype._transformBillingAddress = function(e, t) {
                return (
                  t &&
                    ((e.billingLine1 = t.streetAddress),
                    (e.billingLine2 = t.extendedAddress),
                    (e.billingLine3 = t.line3),
                    (e.billingCity = t.locality),
                    (e.billingState = t.region),
                    (e.billingPostalCode = t.postalCode),
                    (e.billingCountryCode = t.countryCodeAlpha2),
                    (e.billingPhoneNumber = t.phoneNumber),
                    (e.billingGivenName = t.givenName),
                    (e.billingSurname = t.surname)),
                  e
                );
              }),
              (i.prototype._transformShippingAddress = function(e) {
                var t = e.shippingAddress;
                return (
                  t &&
                    ((e.shippingLine1 = t.streetAddress),
                    (e.shippingLine2 = t.extendedAddress),
                    (e.shippingLine3 = t.line3),
                    (e.shippingCity = t.locality),
                    (e.shippingState = t.region),
                    (e.shippingPostalCode = t.postalCode),
                    (e.shippingCountryCode = t.countryCodeAlpha2),
                    delete e.shippingAddress),
                  e
                );
              }),
              (i.prototype._createIframe = function(t) {
                var e,
                  n,
                  r = window.location.href,
                  i = t.response;
                return (
                  (this._bus = new s({
                    channel: a(),
                    merchantUrl: location.href
                  })),
                  (n =
                    this._assetsUrl +
                    "/html/three-d-secure-authentication-complete-frame.html?channel=" +
                    encodeURIComponent(this._bus.channel) +
                    "&"),
                  -1 < r.indexOf("#") && (r = r.split("#")[0]),
                  this._bus.on(s.events.CONFIGURATION_REQUEST, function(e) {
                    e({
                      acsUrl: i.acsUrl,
                      pareq: i.pareq,
                      termUrl:
                        i.termUrl +
                        "&three_d_secure_version=" +
                        A +
                        "&authentication_complete_base_url=" +
                        encodeURIComponent(n),
                      md: i.md,
                      parentUrl: r
                    });
                  }),
                  this._bus.on(
                    m.AUTHENTICATION_COMPLETE,
                    function(e) {
                      this._handleAuthResponse(e, t);
                    }.bind(this)
                  ),
                  (e =
                    this._assetsUrl +
                    "/html/three-d-secure-bank-frame" +
                    o(this._isDebug) +
                    ".html?showLoader=" +
                    t.showLoader),
                  (this._bankIframe = y({
                    src: e,
                    height: 400,
                    width: 400,
                    name: _.LANDING_FRAME_NAME + "_" + this._bus.channel,
                    title: "3D Secure Authorization Frame"
                  })),
                  this._bankIframe
                );
              }),
              (i.prototype._handleAuthResponse = function(e, t) {
                var n = JSON.parse(e.auth_response);
                this._bus.teardown(),
                  t.removeFrame(),
                  h(
                    function() {
                      n.success
                        ? this._verifyCardCallback(
                            null,
                            this._formatAuthResponse(
                              n.paymentMethod,
                              n.threeDSecureInfo
                            )
                          )
                        : n.threeDSecureInfo &&
                          n.threeDSecureInfo.liabilityShiftPossible
                        ? this._verifyCardCallback(
                            null,
                            this._formatAuthResponse(
                              this._lookupPaymentMethod,
                              n.threeDSecureInfo
                            )
                          )
                        : this._verifyCardCallback(
                            new l({
                              type: l.types.UNKNOWN,
                              code: "UNKNOWN_AUTH_RESPONSE",
                              message: n.error.message
                            })
                          );
                    }.bind(this)
                  )();
              }),
              (i.prototype._formatAuthResponse = function(e, t) {
                return {
                  nonce: e.nonce,
                  binData: e.binData,
                  details: e.details,
                  description:
                    e.description && e.description.replace(/\+/g, " "),
                  liabilityShifted: t && t.liabilityShifted,
                  liabilityShiftPossible: t && t.liabilityShiftPossible
                };
              }),
              (i.prototype.teardown = function() {
                return (
                  t(this, e(i.prototype)),
                  d.sendEvent(
                    this._options.client,
                    "three-d-secure.teardown-completed"
                  ),
                  this._bus && this._bus.teardown(),
                  this._bankIframe &&
                    this._bankIframe.parentNode &&
                    this._bankIframe.parentNode.removeChild(this._bankIframe),
                  c.Cardinal &&
                    (c.Cardinal.off("payments.setupComplete"),
                    c.Cardinal.off("payments.validated")),
                  b.resolve()
                );
              }),
              (i.prototype._usesSongbirdFlow = function() {
                return 2 === this._options.version;
              }),
              (i.prototype._createPaymentsSetupCompleteCallback = function(
                t,
                n
              ) {
                var r = this;
                return function(e) {
                  r._getDfReferenceIdPromise
                    ? r._getDfReferenceIdResolveFunction(e.sessionId)
                    : (r._getDfReferenceIdPromise = b.resolve(e.sessionId)),
                    c.clearTimeout(n),
                    d.sendEvent(
                      r._client,
                      "three-d-secure.cardinal-sdk.init.setup-completed"
                    ),
                    t();
                };
              }),
              (i.prototype._createPaymentsValidatedCallback = function() {
                var r = this;
                return function(e, t) {
                  var n = "";
                  switch (
                    (d.sendEvent(
                      r._options.client,
                      "three-d-secure.verification-flow.cardinal-sdk.action-code." +
                        e.ActionCode.toLowerCase()
                    ),
                    e.ActionCode)
                  ) {
                    case "SUCCESS":
                    case "NOACTION":
                    case "FAILURE":
                      r._performJWTValidation(t)
                        .then(function(e) {
                          r._verifyCardCallback(null, e);
                        })
                        .catch(function(e) {
                          r._verifyCardCallback(e);
                        });
                      break;
                    case "ERROR":
                      switch (e.ErrorNumber) {
                        case 10001:
                        case 10002:
                          n = new l(E.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT);
                          break;
                        case 10003:
                        case 10007:
                        case 10009:
                          n = new l(E.THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT);
                          break;
                        case 10005:
                        case 10006:
                          n = new l(E.THREEDS_CARDINAL_SDK_BAD_CONFIG);
                          break;
                        case 10008:
                        case 10010:
                          n = new l(E.THREEDS_CARDINAL_SDK_BAD_JWT);
                          break;
                        case 10011:
                          d.sendEvent(
                            r._options.client,
                            "three-d-secure.verification-flow.canceled"
                          ),
                            (n = new l(E.THREEDS_CARDINAL_SDK_CANCELED));
                          break;
                        case 10004:
                        case 10012:
                        default:
                          n = new l(E.THREEDS_CARDINAL_SDK_ERROR);
                      }
                      (n.details = {
                        originalError: {
                          code: e.ErrorNumber,
                          description: e.ErrorDescription
                        }
                      }),
                        r._verifyCardCallback
                          ? r._verifyCardCallback(n, null)
                          : (r._verifyCardBlockingError = n);
                  }
                };
              }),
              (i.prototype._setupSongbird = function(i) {
                var o = this,
                  e = _.CARDINAL_SCRIPT_SOURCE.sandbox,
                  s = this._client.getConfiguration().gatewayConfiguration
                    .threeDSecure.cardinalAuthenticationJWT,
                  a = Date.now();
                return (
                  (i = i || {}),
                  new b(function(t, n) {
                    var r = c.setTimeout(function() {
                      d.sendEvent(
                        o._client,
                        "three-d-secure.cardinal-sdk.init.setup-timeout"
                      ),
                        n(new l(E.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT));
                    }, i.timeout || g);
                    i.isProduction && (e = _.CARDINAL_SCRIPT_SOURCE.production),
                      p
                        .loadScript({ src: e })
                        .catch(function(e) {
                          return b.reject(
                            u(e, E.THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED)
                          );
                        })
                        .then(function(e) {
                          (o._cardinalScript = e),
                            c.Cardinal.on(
                              "payments.setupComplete",
                              o._createPaymentsSetupCompleteCallback(t, r)
                            ),
                            i.loggingEnabled &&
                              c.Cardinal.configure({
                                logging: { level: "verbose" }
                              }),
                            c.Cardinal.setup("init", { jwt: s }),
                            (o._clientMetadata.cardinalDeviceDataCollectionTimeElapsed =
                              Date.now() - a),
                            c.Cardinal.on(
                              "payments.validated",
                              o._createPaymentsValidatedCallback()
                            );
                        })
                        .catch(function(e) {
                          var t = u(e, {
                            type: E.THREEDS_CARDINAL_SDK_SETUP_FAILED.type,
                            code: E.THREEDS_CARDINAL_SDK_SETUP_FAILED.code,
                            message: E.THREEDS_CARDINAL_SDK_SETUP_FAILED.message
                          });
                          o._getDfReferenceIdPromise
                            ? o._getDfReferenceIdRejectFunction(t)
                            : (o._getDfReferenceIdError = t),
                            c.clearTimeout(r),
                            d.sendEvent(
                              o._client,
                              "three-d-secure.cardinal-sdk.init.setup-failed"
                            ),
                            n(t);
                        });
                  })
                );
              }),
              (i.prototype._getDfReferenceId = function() {
                return this._getDfReferenceIdError
                  ? b.reject(this._getDfReferenceIdError)
                  : (this._getDfReferenceIdPromise ||
                      (this._getDfReferenceIdPromise = new b(
                        function(e, t) {
                          (this._getDfReferenceIdResolveFunction = e),
                            (this._getDfReferenceIdRejectFunction = t);
                        }.bind(this)
                      )),
                    this._getDfReferenceIdPromise);
              }),
              (i.prototype._performJWTValidation = function(e) {
                var t = this._lookupPaymentMethod.nonce,
                  n =
                    "payment_methods/" +
                    t +
                    "/three_d_secure/authenticate_from_jwt",
                  r = this;
                return (
                  d.sendEvent(
                    r._options.client,
                    "three-d-secure.verification-flow.upgrade-payment-method.started"
                  ),
                  this._client
                    .request({
                      method: "post",
                      endpoint: n,
                      data: { jwt: e, paymentMethodNonce: t }
                    })
                    .then(function(e) {
                      var t = e.paymentMethod || r._lookupPaymentMethod,
                        n = r._formatAuthResponse(t, e.threeDSecureInfo);
                      return (
                        d.sendEvent(
                          r._options.client,
                          "three-d-secure.verification-flow.upgrade-payment-method.succeeded"
                        ),
                        b.resolve(n)
                      );
                    })
                    .catch(function(e) {
                      var t = new l({
                        type: E.THREEDS_JWT_AUTHENTICATION_FAILED.type,
                        code: E.THREEDS_JWT_AUTHENTICATION_FAILED.code,
                        message: E.THREEDS_JWT_AUTHENTICATION_FAILED.message,
                        details: { originalError: e }
                      });
                      return (
                        d.sendEvent(
                          r._options.client,
                          "three-d-secure.verification-flow.upgrade-payment-method.errored"
                        ),
                        b.reject(t)
                      );
                    })
                );
              }),
              (R.exports = n.wrapPrototype(i));
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "../../lib/analytics": 14,
          "../../lib/assets": 15,
          "../../lib/assign": 16,
          "../../lib/braintree-error": 18,
          "../../lib/bus": 21,
          "../../lib/constants": 22,
          "../../lib/convert-methods-to-error": 23,
          "../../lib/convert-to-braintree-error": 24,
          "../../lib/deferred": 28,
          "../../lib/methods": 34,
          "../../lib/promise": 35,
          "../../lib/use-min": 36,
          "../../lib/vendor/uuid": 38,
          "../shared/constants": 41,
          "../shared/errors": 42,
          "../shared/events": 43,
          "@braintree/iframer": 3,
          "@braintree/wrap-promise": 10
        }
      ],
      40: [
        function(e, t, n) {
          "use strict";
          var a = e("./external/three-d-secure"),
            c = e("../lib/is-https").isHTTPS,
            r = e("../lib/basic-component-verification"),
            i = e("../lib/create-deferred-client"),
            o = e("../lib/create-assets-url"),
            l = e("../lib/braintree-error"),
            u = e("../lib/analytics"),
            d = e("./shared/errors"),
            f = e("../lib/promise"),
            s = e("@braintree/wrap-promise");
          t.exports = {
            create: s(function(s) {
              var e = "3D Secure";
              return r
                .verify({
                  name: e,
                  client: s.client,
                  authorization: s.authorization
                })
                .then(function() {
                  return i.create({
                    authorization: s.authorization,
                    client: s.client,
                    debug: s.debug,
                    assetsUrl: o.create(s.authorization),
                    name: e
                  });
                })
                .then(function(e) {
                  var t,
                    n,
                    r,
                    i = e.getConfiguration(),
                    o = i.gatewayConfiguration;
                  return (
                    (s.client = e),
                    o.threeDSecureEnabled || (t = d.THREEDS_NOT_ENABLED),
                    "TOKENIZATION_KEY" === i.authorizationType &&
                      (t = d.THREEDS_CAN_NOT_USE_TOKENIZATION_KEY),
                    (n = "production" === o.environment) &&
                      !c() &&
                      (t = d.THREEDS_HTTPS_REQUIRED),
                    2 !== s.version ||
                      o.threeDSecure.cardinalAuthenticationJWT ||
                      (t = d.THREEDS_NOT_ENABLED_FOR_V2),
                    t
                      ? f.reject(new l(t))
                      : (u.sendEvent(s.client, "three-d-secure.initialized"),
                        (r = new a(s)),
                        2 === s.version &&
                          r._setupSongbird({
                            isProduction: n,
                            loggingEnabled: s.loggingEnabled
                          }),
                        r)
                  );
                });
            }),
            VERSION: "3.47.0"
          };
        },
        {
          "../lib/analytics": 14,
          "../lib/basic-component-verification": 17,
          "../lib/braintree-error": 18,
          "../lib/create-assets-url": 25,
          "../lib/create-deferred-client": 27,
          "../lib/is-https": 31,
          "../lib/promise": 35,
          "./external/three-d-secure": 39,
          "./shared/errors": 42,
          "@braintree/wrap-promise": 10
        }
      ],
      41: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            LANDING_FRAME_NAME: "braintreethreedsecurelanding",
            CARDINAL_SCRIPT_SOURCE: {
              production:
                "https://songbird.cardinalcommerce.com/cardinalcruise/v1/songbird.js",
              sandbox:
                "https://songbirdstag.cardinalcommerce.com/cardinalcruise/v1/songbird.js"
            }
          };
        },
        {}
      ],
      42: [
        function(e, t, n) {
          "use strict";
          var r = e("../../lib/braintree-error");
          t.exports = {
            THREEDS_NOT_ENABLED: {
              type: r.types.MERCHANT,
              code: "THREEDS_NOT_ENABLED",
              message: "3D Secure is not enabled for this merchant."
            },
            THREEDS_CAN_NOT_USE_TOKENIZATION_KEY: {
              type: r.types.MERCHANT,
              code: "THREEDS_CAN_NOT_USE_TOKENIZATION_KEY",
              message:
                "3D Secure can not use a tokenization key for authorization."
            },
            THREEDS_HTTPS_REQUIRED: {
              type: r.types.MERCHANT,
              code: "THREEDS_HTTPS_REQUIRED",
              message: "3D Secure requires HTTPS."
            },
            THREEDS_NOT_ENABLED_FOR_V2: {
              type: r.types.MERCHANT,
              code: "THREEDS_NOT_ENABLED_FOR_V2",
              message: "3D Secure version 2 is not enabled for this merchant."
            },
            THREEDS_CARDINAL_SDK_SETUP_FAILED: {
              type: r.types.UNKNOWN,
              code: "THREEDS_CARDINAL_SDK_SETUP_FAILED",
              message:
                "Something went wrong setting up Cardinal's Songbird.js library."
            },
            THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED: {
              type: r.types.NETWORK,
              code: "THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED",
              message: "Cardinal's Songbird.js library could not be loaded."
            },
            THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT: {
              type: r.types.UNKNOWN,
              code: "THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT",
              message: "Cardinal's Songbird.js took too long to setup."
            },
            THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT: {
              type: r.types.UNKNOWN,
              code: "THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT",
              message: "Cardinal's API took too long to respond."
            },
            THREEDS_CARDINAL_SDK_BAD_CONFIG: {
              type: r.types.MERCHANT,
              code: "THREEDS_CARDINAL_SDK_BAD_CONFIG",
              message:
                "JWT or other required field missing. Please check your setup configuration."
            },
            THREEDS_CARDINAL_SDK_BAD_JWT: {
              type: r.types.MERCHANT,
              code: "THREEDS_CARDINAL_SDK_BAD_JWT",
              message:
                "Cardinal JWT missing or malformed. Please check your setup configuration."
            },
            THREEDS_CARDINAL_SDK_ERROR: {
              type: r.types.UNKNOWN,
              code: "THREEDS_CARDINAL_SDK_ERROR",
              message:
                "A general error has occurred with Cardinal. See description for more information."
            },
            THREEDS_CARDINAL_SDK_CANCELED: {
              type: r.types.CUSTOMER,
              code: "THREEDS_CARDINAL_SDK_CANCELED",
              message: "Canceled by user."
            },
            THREEDS_AUTHENTICATION_IN_PROGRESS: {
              type: r.types.MERCHANT,
              code: "THREEDS_AUTHENTICATION_IN_PROGRESS",
              message:
                "Cannot call verifyCard while existing authentication is in progress."
            },
            THREEDS_MISSING_VERIFY_CARD_OPTION: {
              type: r.types.MERCHANT,
              code: "THREEDS_MISSING_VERIFY_CARD_OPTION"
            },
            THREEDS_JWT_AUTHENTICATION_FAILED: {
              type: r.types.UNKNOWN,
              code: "THREEDS_JWT_AUTHENTICATION_FAILED",
              message:
                "Something went wrong authenticating the JWT from Cardinal"
            },
            THREEDS_NO_VERIFICATION_PAYLOAD: {
              type: r.types.MERCHANT,
              code: "THREEDS_NO_VERIFICATION_PAYLOAD",
              message: "No verification payload available."
            },
            THREEDS_METHOD_DEPRECATED: {
              type: r.types.MERCHANT,
              code: "THREEDS_METHOD_DEPRECATED"
            },
            THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN: {
              type: r.types.INTERNAL,
              code: "THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN",
              message: "Term Url must be on a Braintree domain."
            }
          };
        },
        { "../../lib/braintree-error": 18 }
      ],
      43: [
        function(e, t, n) {
          "use strict";
          var r = e("../../lib/enumerate");
          t.exports = r(["AUTHENTICATION_COMPLETE"], "threedsecure:");
        },
        { "../../lib/enumerate": 29 }
      ]
    },
    {},
    [40]
  )(40);
});
